module.exports = __webpack_public_path__ + "images/e8271fc32829af31353e97c4c94acaf8-Frontpoint_illu_lineart_Decal.png";